import { render, staticRenderFns } from "./PprRptGrp.vue?vue&type=template&id=df80a800&"
import script from "./PprRptGrp.vue?vue&type=script&lang=js&"
export * from "./PprRptGrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports